import { createApiClient } from '@/core/api/index';
import { useCallback, useMemo } from 'react';
import type { NotificationKeys } from '../models';
import { NOTIFICATION_ENDPOINTS } from '../constants';

export const useNotificationService = () => {
  const clients = useMemo(
    () => ({
      real: createApiClient({ isMock: false }),
      mock: createApiClient({ isMock: true }),
    }),
    []
  );

  //List Notifications
  const listNotifications = useCallback(
    async (params?: {
      page?: number;
      limit?: number;
      pageSize?: number;
      search?: string;
      searchTerm?: string;
      sortBy?: string;
      sortOrder?: string;
      customerID?: string;
      tenantId?: string;
    }) => {
      const MOCK_ENABLED = false;
      const apiClient = MOCK_ENABLED ? clients.mock : clients.real;
      const response = await apiClient.get(NOTIFICATION_ENDPOINTS.LIST, {
        params,
      });
      return response.data.data;
    },
    [clients.mock, clients.real]
  );

  
//Create Notifications
  const createNotification = useCallback(
    async (userData: NotificationKeys) => {
      const MOCK_ENABLED = false;
      const apiClient = MOCK_ENABLED ? clients.mock : clients.real;
      const response = await apiClient.post(
        NOTIFICATION_ENDPOINTS.CREATE,
        userData
      );
      return response.data;
    },
    [clients.mock, clients.real]
  );

// Notifications Detail
  const getNotificationById = useCallback(async (id: string) => {
    const MOCK_ENABLED = false;
    const apiClient = MOCK_ENABLED ? clients.mock : clients.real;
    const response = await apiClient.get(`${NOTIFICATION_ENDPOINTS.DETAIL(id)}`);
    return response.data.data;
  }, [clients.mock, clients.real]);


  return {
    createNotification,
    listNotifications,
    getNotificationById
  };

};

